import type { FilterConfig } from 'types/filter-page'

import BooleanForm from './filter-forms/boolean'
import DateForm from './filter-forms/date'
import DropdownForm from './filter-forms/dropdown'
import DurationForm from './filter-forms/duration'
import GroupForm from './filter-forms/group'
import NumberForm from './filter-forms/number'
import TagsForm from './filter-forms/tags'
import TextForm from './filter-forms/text'
import YearForm from './filter-forms/year'
import { formatBadgeLabel } from './utils'

export const discoDefaultMetadata = [
  'Artist',
  'Title',
  'Album',
  'BPM',
  'Release Date',
  'Composer',
  'Genre',
  'Grouping',
  'Client Note',
  'Comment',
  'Internal Note',
  'Lyrics',
  'Year',
]

export const filterDataTypes: FilterConfig[] = [
  {
    id: 'text',
    component: TextForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'boolean',
    component: BooleanForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'tags',
    component: TagsForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'date',
    component: DateForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'partial_date',
    component: DateForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'year',
    component: YearForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'number',
    component: NumberForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'duration',
    component: DurationForm,
    badgeLabel: state => {
      if (!state.value) return null
      const withUnit = (v: string) => `${v}s`
      // Custom wording for the open-ended bounds: the generic gte/lte labels
      // ("is after or equal to") read as dates, not durations.
      if (state.operator === 'gte')
        return `is at least ${withUnit(state.value)}`
      if (state.operator === 'lte') return `is at most ${withUnit(state.value)}`
      return formatBadgeLabel({
        ...state,
        value: Array.isArray(state.value)
          ? state.value.map(withUnit)
          : state.value,
      })
    },
  },
  {
    id: 'group',
    component: GroupForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'dropdown_single',
    component: DropdownForm,
    badgeLabel: formatBadgeLabel,
  },
  {
    id: 'dropdown_multi',
    component: DropdownForm,
    badgeLabel: formatBadgeLabel,
  },
]
